import React from 'react';
import '../App.css';

export default function MintSection (){
    return(
        <div className="mint__section">
            <div className="mint-section__container">
                <h1 className="text-blue mint-section__header">Mint your BadPoles Now</h1>
                <div className="container--center"><span className="btn--blue-mint mint-section__btn">Mint nft</span></div>
            </div>
            <h2 className='mint-section__header text-blue' >What to expect next ...</h2>
            <p className='mint-section__text text-blue' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Optio laboriosam ducimus animi veniam quisquam voluptas, sed dignissimos veritatis ex cumque.</p>

        </div>
    )
}